import React, { useContext, useEffect, useRef, useState } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useNavigate } from "react-router";
import { Col, Row, Table } from "antd";
import { saveExecutiveSearchList } from "../../actionCreator/executiveListingActionCreater";
import { saveSearchList } from "../../actionCreator/companyListingActionCreater";
import { getUserInfo } from "../../utils/utils";
import { AuthContext } from "../../context/AuthContext";
import CustomPagination from "../../common/CustomPagination";
import { useAlert } from "../../context/AlertProvider";

const SaveSearchReport = ({ userId }) => {
  const navigate = useNavigate();
  const { user, isExecutiveView, isCompanyView } = useContext(AuthContext);
  const dispatch = useDispatch();
  const { showAlert } = useAlert();
  const [isLoading, setIsLoading] = useState(false);
  const requestRef = useRef(0);

  const isMyDashboard = user?.id == userId;
  const executiveSaveSearchList = useSelector(
    (state) => state.executiveListingReducer.saveSearchList,
  );
  const companySaveSearchList = useSelector(
    (state) => state.companyListingReducer.saveSearchList,
  );

  useEffect(() => {
    if (Object.keys(getUserInfo()).length) {
      const requestId = ++requestRef.current;
      setIsLoading(true);
      Promise.all([
        dispatch(saveExecutiveSearchList(userId)),
        dispatch(saveSearchList(userId)),
      ]).finally(() => {
        if (requestId === requestRef.current) {
          setIsLoading(false);
        }
      });
    }
  }, [dispatch, userId]);

  const dataSource = companySaveSearchList;
  const executiveDataSource = executiveSaveSearchList;

  let filterDataSource = [];
  let filterExecutiveDataSource = [];
  dataSource.map((obj) => {
    let obj1 = { text: obj.fullName, value: obj.fullName };
    filterDataSource.push(obj1);
  });
  executiveDataSource.map((obj) => {
    let obj1 = { text: obj.fullName, value: obj.fullName };
    filterExecutiveDataSource.push(obj1);
  });
  const doFilterByCompany = (row) => {
    if (!isMyDashboard) {
      showAlert(
        "info",
        "Redirection is not allowed when viewing another user's dashboard.",
      );
      return;
    }
    const queryObject = JSON.parse(row?.dataDump);
    const queryString = new URLSearchParams(queryObject).toString();
    navigate(`/search-company?${queryString}`);
  };
  const doFilterByExecutive = (row) => {
    if (!isMyDashboard) {
      showAlert(
        "info",
        "Redirection is not allowed when viewing another user's dashboard.",
      );
      return;
    }
    const queryObject = JSON.parse(row?.dataDump);
    const queryString = new URLSearchParams(queryObject).toString();
    navigate(`/search-executive?${queryString}`);
  };
  const columns = [
    {
      title: "Search",
      dataIndex: "fullName",
      key: "fullName",
      filters: filterDataSource,
      onFilter: (value, record) => record.fullName.startsWith(value),
      filterSearch: true,
      width: "40%",
      render: (text, row) => {
        return (
          <>
            <a
              style={{ cursor: "pointer" }}
              onClick={() => doFilterByCompany(row)}
            >
              {text}
            </a>
          </>
        );
      },
    },
    {
      title: "Source",
      dataIndex: "source",
      key: "source",
    },
  ];

  const executiveColumns = [
    {
      title: "Search",
      dataIndex: "fullName",
      key: "fullName",
      filters: filterExecutiveDataSource,
      onFilter: (value, record) => record.fullName.startsWith(value),
      filterSearch: true,
      width: "40%",
      render: (text, row) => {
        return (
          <>
            <a
              style={{ cursor: "pointer" }}
              onClick={() => doFilterByExecutive(row)}
            >
              {text}
            </a>
          </>
        );
      },
    },
    {
      title: "Source",
      dataIndex: "source",
      key: "source",
    },
  ];

  return (
    <Row gutter={[20, 20]} className="tw-mt-6">
      {isCompanyView && (
        <Col xs={24} lg={12}>
          <div className="tw-p-6 tw-border tw-border-solid tw-border-border-secondary tw-rounded-[10px] tw-bg-white tw-h-full">
            <div className="tw-flex tw-items-center tw-gap-3 tw-text-base tw-font-semibold tw-text-text-primary tw-pb-4 tw-mb-4 tw-border-b tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-border-secondary">
              Company saved search
            </div>
            <div>
              <Table
                className={`tw-custom-table ${dataSource?.length > 10 ? "tw-saved-search" : "tw-saved-search-limited-data"}`}
                loading={isLoading}
                pagination={false}
                dataSource={dataSource}
                columns={columns}
              />
              {dataSource?.length > 10 && (
                <CustomPagination total={dataSource?.length} pageSize={10} />
              )}
            </div>
          </div>
        </Col>
      )}
      {isExecutiveView && (
        <Col xs={24} lg={12}>
          <div className="tw-p-6 tw-border tw-border-solid tw-border-border-secondary tw-rounded-[10px] tw-bg-white tw-h-full">
            <div className="tw-flex tw-items-center tw-gap-3 tw-text-base tw-font-semibold tw-text-text-primary tw-pb-4 tw-mb-4 tw-border-b tw-border-t-0 tw-border-l-0 tw-border-r-0 tw-border-solid tw-border-border-secondary">
              Executive saved search
            </div>

            <div>
              <Table
                className={`tw-custom-table ${dataSource?.length > 10 ? "tw-saved-search" : "tw-saved-search-limited-data"}`}
                loading={isLoading}
                pagination={false}
                dataSource={executiveDataSource}
                columns={executiveColumns}
              />
              {dataSource?.length > 10 && (
                <CustomPagination
                  total={executiveDataSource?.length}
                  pageSize={10}
                />
              )}
            </div>
          </div>
        </Col>
      )}
    </Row>
  );
};

export default SaveSearchReport;
